const mediaItems = [
  {
    title: '独家：某选秀节目后台选手冲突完整录像流出',
    tag: '独家爆料',
    time: '2小时前',
    views: '8.6万',
    img: 'https://readdy.ai/api/search-image?query=Blurry%20backstage%20camera%20footage%20style%20with%20dramatic%20warm%20lighting%2C%20entertainment%20show%20behind%20the%20scenes%20aesthetic%2C%20dark%20corners%20with%20mysterious%20atmosphere%2C%20cinematic%20documentary%20style%2C%20low%20light%20photography%20with%20grain%20texture&width=640&height=360&seq=media-01-2026&orientation=landscape',
  },
  {
    title: '知名导师录制现场被曝临时改规则引发选手不满',
    tag: '现场直击',
    time: '5小时前',
    views: '6.3万',
    img: 'https://readdy.ai/api/search-image?query=TV%20studio%20set%20with%20judges%20panel%20in%20dramatic%20lighting%2C%20reality%20show%20recording%20atmosphere%2C%20warm%20stage%20lights%20with%20tension%2C%20cinematic%20behind%20the%20scenes%20photography%2C%20dark%20moody%20aesthetic&width=640&height=360&seq=media-02-2026&orientation=landscape',
  },
  {
    title: '电竞大赛决赛疑似假赛录音曝光引全网热议',
    tag: '重磅内幕',
    time: '8小时前',
    views: '12.1万',
    img: 'https://readdy.ai/api/search-image?query=Esports%20arena%20with%20dramatic%20red%20and%20blue%20lighting%2C%20gaming%20competition%20stage%2C%20tense%20atmosphere%20with%20spotlights%2C%20cyberpunk%20aesthetic%20with%20dark%20moody%20tone%2C%20professional%20esports%20photography&width=640&height=360&seq=media-03-2026&orientation=landscape',
  },
  {
    title: '网红主播大赛票数异常波动数据详细分析',
    tag: '深度调查',
    time: '12小时前',
    views: '5.8万',
    img: 'https://readdy.ai/api/search-image?query=Digital%20data%20dashboard%20with%20dramatic%20red%20glow%2C%20analytics%20screens%20in%20dark%20room%2C%20mysterious%20hacker%20aesthetic%2C%20numbers%20and%20charts%20with%20warm%20amber%20highlights%2C%20cinematic%20tech%20noir%20style&width=640&height=360&seq=media-04-2026&orientation=landscape',
  },
  {
    title: '综艺节目选手私下关系曝光聊天记录全截图',
    tag: '吃瓜速递',
    time: '1天前',
    views: '9.7万',
    img: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20showing%20chat%20messages%20in%20dark%20environment%2C%20dramatic%20warm%20lighting%20on%20phone%2C%20mysterious%20night%20aesthetic%2C%20gossip%20and%20secrets%20vibe%2C%20cinematic%20low%20key%20photography%20with%20shadows&width=640&height=360&seq=media-05-2026&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="mb-8 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            独家爆料
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-600">
            一手大赛内幕视频与录音，每日大赛黑料独家呈现
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-300 transition-all cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute top-2 left-2 px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded whitespace-nowrap">
                  {item.tag}
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-background-50/90 flex items-center justify-center">
                    <i className="ri-play-fill text-primary-600 text-xl"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 bg-background-950/70 text-background-50 text-xs rounded whitespace-nowrap">
                  {item.views} 次观看
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-500">{item.time}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}